/**
 * Header.
 */
(() => {
    /**
     * A variable to store a timeout (for use with clearTimeout).
     */
    let debounceTimeout;

    /**
     * How often we should update header height when resizing.
     */
    const debounceDelay = 100;

    let header = document.querySelector('.js-site-header');

    if (!header) {
        return;
    }

    let doc = document.documentElement;
    let primary = header.querySelector('.js-primary-menu-bar');
    let secondary = doc.querySelector('.js-secondary-menu-bar');

    /**
     * Stores the height of the header element and some child elements.
     */
    function storeHeightValues() {
        /**
         * We need to use `.getBoundingClientRect().height` instead of `.clientHeight` for better
         * precision. Imprecise measurement could cause visual bugs when calculating things with
         * these values.
         */
        H_Tools.header.setHeight(header.getBoundingClientRect().height);
        if (primary) {
            doc.style.setProperty(
                '--primary-menu-bar-height',
                `${primary.getBoundingClientRect().height}px`
            );
        }
        if (secondary) {
            doc.style.setProperty(
                '--secondary-menu-bar-height',
                `${secondary.getBoundingClientRect().height}px`
            );
        }
    }

    new ResizeObserver((entries) => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            storeHeightValues();
        }, debounceDelay);
    }).observe(header);

    storeHeightValues();
})();
